
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/navbar-preview",
      function () {
        return require("private-next-pages/b/navbar-preview.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b/navbar-preview"])
      });
    }
  